import UtilityBar from "./UtilityBar";
import Header from "./Header";
import Footer from "./Footer";
import AutoTranslate from "@/lib/autoTranslate";

export default function PublicLayout({ children }) {
  return (
    <div className="min-h-screen flex flex-col">
      <AutoTranslate />
      <UtilityBar />
      <Header />
      <main className="flex-1">{children}</main>
      <Footer />
    </div>
  );
}
